import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/LanguageContext";

const LOGO_URL = "/logo-sciad.png";

const Footer = ({ onAdminClick }) => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="py-12 bg-[#0B1121] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="SCIAD" className="h-10 w-auto" />
          </div>
          
          <p className="text-slate-400 text-sm">
            &copy; {currentYear} {t("footer_copyright")}
          </p>
          
          <div className="flex gap-6 text-sm text-slate-400">
            <Link to="/legal/mentions-legales" className="hover:text-white transition-colors" data-testid="footer-mentions-legales">{t("footer_legal")}</Link>
            <Link to="/legal/politique-confidentialite" className="hover:text-white transition-colors" data-testid="footer-politique">{t("footer_privacy")}</Link>
            <button
              onClick={onAdminClick}
              className="hover:text-white transition-colors"
              data-testid="footer-admin-link"
            >
              {t("footer_admin")}
            </button>
          </div>
        </div>
        <div className="mt-6 text-right">
          <span className="text-[10px] text-slate-600" data-testid="app-version">v8.0</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
